import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';
import { ScriptLoaderService } from '../../../_services/script-loader.service';
import {AppService} from "../../../app.service";


@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body",
    templateUrl: "./default.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class DefaultComponent implements OnInit {


    constructor(public appService: AppService) {

    }
    ngOnInit() {

    }

}


// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/front-user-dev/src/app/theme/pages/default/default.component.ts